// here we 'map' env vars to constants, to use them later in app

export const API_URL = process.env.REACT_APP_API_URL || "https://app.meditalent.pl"
